<template>
  <div class="main-wrapper">
    <Header></Header>
    <Sidebar></Sidebar>
    <div class="page-wrapper">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Sidebar from "./Sidebar.vue";
export default {
  components: {
    Header,
    Sidebar,
  },
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Layout.vue